export const environment = {
  CDN_URL:
    'https://media-assets-cdn.s3.us-east-2.amazonaws.com/',
  CORE_API_URL: 'https://app-dev.simpleproof.com',
  WEB_URL: 'https://verify.simpleproof.xyz',
};
